import { render, staticRenderFns } from "./wishes.vue?vue&type=template&id=09b37291&scoped=true&"
import script from "./wishes.vue?vue&type=script&lang=js&"
export * from "./wishes.vue?vue&type=script&lang=js&"
import style0 from "./wishes.vue?vue&type=style&index=0&id=09b37291&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b37291",
  null
  
)

export default component.exports